import React, { useState, useEffect } from 'react';
import { doPost, doPut } from 'utils/apiUtil.js'
import { endpoint } from 'utils/constants.js'
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import TextField from '@material-ui/core/TextField';
import { format } from 'date-fns';

const FormUser = (props) => {
  const { handleClose, user, selectedUser, getusers } = props;

  const [state, setstate] = useState(null);
  const [resetPassword, setResetPassword] = useState(false);

  const getDefaultHeader = () => {
    return { Authorization: `Bearer ${user.token}` };
  };

  const handleChange = (field) => (event) => {
    setstate({
      ...state,
      [field]: event.target.value
    });
  };

  const handleCheckboxChange = (field) => (event) => {
    setstate({
      ...state,
      [field]: event.target.checked ? new Date().toISOString() : null
    });
  };

  // 🔥 RESET PASSWORD LOGIC
  const handleResetPasswordToggle = (event) => {
    setResetPassword(event.target.checked);

    setstate({
      ...state,
      password: event.target.checked ? "pahoa123" : ""
    });
  };

  const submit = async () => {
    const payload = {
      ...state,
      password: resetPassword ? state.password : undefined
    };

    const response = await doPut(
      endpoint.user_update_date, // ganti ke endpoint user update kalau ada
      payload,
      "update user",
      getDefaultHeader()
    );

    if (response && !response.error) {
      getusers();
      handleClose();
    }
  };

  useEffect(() => {
    if (selectedUser) {
      setstate({
        ...selectedUser,
        password: ""
      });
    }
  }, [selectedUser]);

  if (!state) return null;

  return (
    <>
      <DialogContent>

        <Grid container spacing={2}>

          {/* NAME */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Name Student"
              value={state.name_student || ""}
              onChange={handleChange("name_student")}
            />
          </Grid>

          {/* EMAIL */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Email"
              value={state.email || ""}
              onChange={handleChange("email")}
            />
          </Grid>

          {/* PHONE */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Telephone"
              value={state.telephone || ""}
              onChange={handleChange("telephone")}
            />
          </Grid>

          {/* NIY */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="NIY"
              value={state.niy || ""}
              onChange={handleChange("niy")}
            />
          </Grid>

          {/* VERIFIED */}
          <Grid item xs={12}>
            <label>
              <input
                type="checkbox"
                checked={!!state.email_verified_at}
                onChange={handleCheckboxChange("email_verified_at")}
              />
              &nbsp; Email Verified
            </label>
          </Grid>

          {/* RESET PASSWORD */}
          <Grid item xs={12}>
            <label>
              <input
                type="checkbox"
                checked={resetPassword}
                onChange={handleResetPasswordToggle}
              />
              &nbsp; Reset Password (default: pahoa123)
            </label>

            <TextField
              fullWidth
              style={{ marginTop: 10 }}
              label="Password"
              value={state.password || ""}
              onChange={handleChange("password")}
              disabled={!resetPassword}
              helperText={!resetPassword ? "Check reset password to enable edit" : ""}
            />
          </Grid>

          {/* CREATED AT */}
          <Grid item xs={12}>
            Created At:{" "}
            {state.created_at
              ? format(new Date(state.created_at), 'yyyy-MM-dd')
              : "-"}
          </Grid>

        </Grid>

      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>

        <Button onClick={submit} color="secondary" variant="contained">
          Save
        </Button>
      </DialogActions>
    </>
  );
};

export default FormUser;